export default __webpack_public_path__ + "static/media/flash04.03eeab5d.png";